module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Gold Aluminum + Pink Sand Open.709ea497.png";